import React, { useState, useEffect, useContext } from 'react';
import { Dialog, Stepper, Step, StepLabel } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import moment from 'moment';
import useFetch from '../hooks/useFetch';
import './FileuploadMoal.scss';
import { AppDataContext, UserContext, ErrorMessageContext } from '../contexts';

export default function FileuploadModal(
  { modalupload,
    setmodalupload,
    valuationDate,
    setValuationdatauploaded, 
    filelocation,
    getProjectCompanies,
  },
) {
  const [progress, setProgress] = useState(0);
  const [, setOptions] = useFetch();
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [currentstep, setCurrentStep] = useState("Uploading model file");
  const [compsSteps, setCompsSteps] = useState([
    'Uploading model file', // 30 seconds
    'Reading and analyzing model data', // 30 seconds
    'Creating new ASC 820', // 25 seconds
    'Adding to database', // 25 seconds
    'Updating Industry & Comps Data', // 40 seconds
    'Finalizing', // rest on this step
  ]);
  const { userData, setUserData } = useContext(UserContext);
  const { currentInvestorId } = useContext(AppDataContext);
  const { setShowErrorMessage } = useContext(ErrorMessageContext);

  function closemodel(success = true) {
    setTimeout(() => {
      setProgress(0);
      setmodalupload(false);
      if (success) {
        setValuationdatauploaded(true);
        getProjectCompanies();
      }
    }, 5000);
  }

  useEffect(() => {
    setCurrentStep(compsSteps[0]);
    setCurrentStepIndex(0);
    if (modalupload === true) {
      // Slow down the step transitions to span 2-3 minutes
      setTimeout(() => {
        setCurrentStep(compsSteps[1]);
        setCurrentStepIndex(1);
        setTimeout(() => {
          setCurrentStep(compsSteps[2]);
          setCurrentStepIndex(2);
          setTimeout(() => {
            setCurrentStep(compsSteps[3]);
            setCurrentStepIndex(3);
            setTimeout(() => {
              setCurrentStep(compsSteps[4]);
              setCurrentStepIndex(4);
              setTimeout(() => {
                setCurrentStep(compsSteps[5]);
                setCurrentStepIndex(5);
              }, 40000); // Increase from 25000
            }, 25000); // Increase from 2000
          }, 25000); // Increase from 3000
        }, 30000); // Increase from 3000
      }, 30000); // Increase from 9000
    }
  }, [modalupload]);

  useEffect(() => {
    if (modalupload) {
      const enterpriseid = userData.userAttributes.enterpriseCompanyId;
      const queryParams = new URLSearchParams(window.location.search);
      const pId = queryParams.get('pId');
      const requestBody = {
        enterpriseCompanyId: enterpriseid,
        investorCompanyId: currentInvestorId,
        projectId: pId,
        documentType: '820',
        documentLocation: filelocation,
        valuationDate: moment(valuationDate).format('YYYY-MM-DD'),
      };
      const options = {
        method: 'POST',
        url: '/documents/process-rw-820',
        body: requestBody,
        onSuccess: (data) => {
          setProgress(100);
          setCurrentStepIndex(5);
          setCurrentStep(compsSteps[5]);
          closemodel(true);
        },
        onError: (error) => {
          let message;

          if (typeof error === 'string') {
            message = error;
          } else if (error?.message) {
            message = error.message;
          } else if (typeof error === 'object') {
            message = JSON.stringify(error);
          } else {
            message = 'Invalid model file. Model file has some issues.';
          }
          closemodel(false);
          setShowErrorMessage(message);
        },
      };
      setOptions(options);
    }
    
    // Slow down the progress increment to take ~3 minutes to reach 100%
    const totalDuration = 180000; // 3 minutes = 180,000 ms
    const maxProgress = 100; // Only go to 95% with animation
    const updateInterval = 500; // Update every 500ms
    
    // Calculate a smaller increment to stretch over 3 minutes
    const increment = (maxProgress * updateInterval) / totalDuration;
    
    const interval = setInterval(() => {
      if (modalupload) {
        setProgress((prev) => {
          if (prev >= maxProgress) {
            return maxProgress; // Cap at maxProgress until API complete
          }
          return prev + increment; // Smaller increment for slower progress
        });
      }
    }, updateInterval);
    
    return () => clearInterval(interval);
  }, [modalupload]);
  
  return (
    <Dialog
      className="uploadvaluationtimmer"
      open={modalupload}
      disableScrollLock
    >
      <div className="add-companies-block">
        <div className="header-intro-wrapper w-100">
          <div className="header-text-wrapper w-100">
            <div className="run-comps-tool-tip-header">
              <p>{currentstep}</p>
            </div>
            <div className="linear-progress">
              <div className="linear-progress-header">
                <span>Status</span>
                <span className="current-step">{`${Math.round(progress)}%`}</span>
              </div>
              <LinearProgress variant="determinate" value={progress} />
            </div>
            <Stepper activeStep={currentStepIndex} orientation="vertical">
              {compsSteps.map((label) => (
                <Step key={label} className="individual-step">
                  <StepLabel className="steper_label_custom">{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
      </div>
    </Dialog>
  );
}